import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { routes } from '@/routes/routes'
import styled from 'styled-components'

const GNBContainer = styled.nav`
  display: flex;
  gap: 20px;
`

const MenuItem = styled(Link)`
  text-decoration: none;
  color: #333333;
  font-size: 1rem;
  font-weight: 600;
  transition: color 0.3s ease;

  &.active {
    color: #ff7043;
  }

  &:hover {
    color: #ff7043;
  }

  &:focus {
    outline: none;
  }
`
const DropdownMenu = styled('div')`
  position: relative;
  text-decoration: none;
  color: #333333;
  font-size: 1rem;
  font-weight: 600;
  transition: color 0.3s ease;

  &.active {
    color: #ff7043;
  }

  &:hover {
    color: #ff7043;
    cursor: pointer;
  }

  &:focus {
    outline: none;
  }
`
const DropdownBox = styled('div')`
  position: absolute;
  top: 100%;
  left: 0;
  background-color: white;
  border: 1px solid #ccc;
  padding: 0.5rem;
  z-index: 9999;

  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`
const DropdownItem = styled(Link)`
  display: block;
  text-decoration: none;
  color: #333333;
  font-size: 1rem;
  font-weight: 600;
  transition: color 0.3s ease;
  margin-bottom: 0.5rem;

  &.active {
    color: #ff7043;
  }

  &:hover {
    color: #ff7043;
  }

  &:focus {
    outline: none;
  }
`

const GNB: React.FC = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const [activeDropdown, setActiveDropdown] = useState('')

  const handleMenuClick = (path: string) => {
    if (location.pathname === path) {
      navigate(0)
    }
  }

  const handleDropDownClick = (label: string) => {
    setActiveDropdown(label)
  }

  const isMenuItemActive = (path: string) => {
    return location.pathname.startsWith(path)
  }

  const handleClickOutside = (e: any) => {
    if (
      typeof e?.target?.className !== 'string' ||
      e.target.className.indexOf('dropdown') < 0
    ) {
      // 드롭다운 관련 영역 아니면 드롭다운 닫기
      setActiveDropdown('')
    }
  }

  useEffect(() => {
    setActiveDropdown('')
  }, [location])

  useEffect(() => {
    document.addEventListener('click', handleClickOutside)

    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [])

  return (
    <GNBContainer>
      {routes
        .filter((route) => route.label)
        .map((route, index) =>
          route.parent ? (
            <></>
          ) : route.isDropdown ? (
            <DropdownMenu
              className="dropdownMenu"
              key={index}
              onClick={() => handleDropDownClick(route.label)}
            >
              {route.label}
              {activeDropdown == route.label && (
                <DropdownBox className="dropdownBox">
                  {routes
                    .filter((subRoute) => subRoute.parent == route.label)
                    .map((subRoute, subIndex) => (
                      <DropdownItem
                        key={subIndex}
                        to={subRoute.path ?? '/'}
                        onClick={() => handleMenuClick(subRoute.path ?? '/')}
                        className={
                          isMenuItemActive(subRoute.path ?? '')
                            ? 'dropdownItem active'
                            : 'dropdownItem'
                        }
                      >
                        {subRoute.label}
                      </DropdownItem>
                    ))}
                </DropdownBox>
              )}
            </DropdownMenu>
          ) : (
            <MenuItem
              key={index}
              to={route.path ?? '/'}
              onClick={() => handleMenuClick(route.path ?? '/')}
              className={isMenuItemActive(route.path ?? '') ? 'active' : ''}
            >
              {route.label}
            </MenuItem>
          ),
        )}
    </GNBContainer>
  )
}

export default GNB
